import React, { useState, useEffect } from 'react';
import { supabase } from '../../../utils/supabaseClient';
import styles from './adminPageMatches.module.css';
import { User } from "@supabase/supabase-js";
import Header from "../../header/header";
import {NavLink} from "react-router-dom";

const adminPageMenu = [
    {
        name: 'Cities & counties',
        link: '/admin/geo'
    },
    {
        name: 'News',
        link: '/admin/news'
    },
    {
        name: 'Teams',
        link: '/admin/teams'
    },
    {
        name: 'Matches',
        link: '/admin/matches'
    }
]
interface AdminPageProps {
    user: User
}
interface Match {
    id: number;
    name: string;
    status: string;
    type: string;
    actual_start_time: string;
    fk_team_host: number;
    host_team_name: {
        name: string;
    };
    fk_team_guest: number;
    guest_team_name: {
        name: string;
    };
    fk_tournament: number;
    tournament?: {
        id: number;
        name: string;
        type: string;
        fk_parent?: number;
    };
    host_team?: {
        name: string;
    };
    guest_team?: {
        name: string;
    };
}

interface NewMatch {
    name: string;
    status: string;
    type: string;
    actual_start_time: string;
    fk_team_host: number;
    fk_team_guest: number;
    fk_tournament: number;
    is_published: boolean;
}


const AdminPageMatches: React.FC<AdminPageProps> = () => {
    const [matches, setMatches] = useState<Match[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [newMatch, setNewMatch] = useState<NewMatch>({
        name: '',
        status: 'Scheduled',
        type: '',
        actual_start_time: '',
        fk_team_host: 0,
        fk_team_guest: 0,
        fk_tournament: 0,
        is_published: false,
    });
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [teams, setTeams] = useState<{id: number, name: string}[]>([]);
    const [tournaments, setTournaments] = useState<{id: number, name: string}[]>([]);

    useEffect(() => {
        fetchMatches();
        fetchTeams();
        fetchTournaments();
    }, []);

    const fetchTeams = async () => {
        const { data, error } = await supabase.from('teams').select('id, name');
        if (error) console.error('Error fetching teams:', error);
        else setTeams(data || []);
    };

    const fetchTournaments = async () => {
        const { data, error } = await supabase.from('tournaments').select('id, name');
        if (error) console.error('Error fetching tournaments:', error);
        else setTournaments(data || []);
    };

    const handleCreateMatch = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const { data, error } = await supabase
                .from('matches')
                .insert(newMatch)
                .single();

            if (error) throw error;

            // Вместо добавления нового матча в состояние, обновляем весь список
            await fetchMatches();

            setIsModalOpen(false);
            setNewMatch({
                name: '',
                status: 'Scheduled',
                type: '',
                actual_start_time: '',
                fk_team_host: 0,
                fk_team_guest: 0,
                fk_tournament: 0,
                is_published: false
            });
        } catch (err) {
            setError('Error creating match. Please try again.');
            console.error('Error creating match:', err);
        } finally {
            setIsLoading(false);
        }
    };

    const fetchMatches = async () => {
        setIsLoading(true);
        setError(null);
        try {
            const { data, error } = await supabase
                .from('matches')
                .select(`
                    *,
                    tournament:tournaments(name),
                    host_team:teams!matches_fk_team_host_fkey(name),
                    guest_team:teams!matches_fk_team_guest_fkey(name)
                `)
                .order('actual_start_time', { ascending: false });
            if (error) throw error;
            setMatches(data || []);
        } catch (err) {
            setError('Error fetching matches. Please try again.');
            console.error('Error fetching matches:', err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleDeleteMatch = async (matchId: number) => {
        if (window.confirm('Are you sure you want to delete this match?')) {
            try {
                const { error } = await supabase
                    .from('matches')
                    .delete()
                    .eq('id', matchId);
                if (error) throw error;
                fetchMatches(); // Обновляем список матчей после удаления
            } catch (err) {
                setError('Error deleting match. Please try again.');
                console.error('Error deleting match:', err);
            }
        }
    };

    console.log(matches)

    return (
        <>
        <Header title={'Admin panel // Matches'} menu={adminPageMenu}/>
        <div className={styles.adminPanel}>
            {error && <div className={styles.error}>{error}</div>}
            <button onClick={() => setIsModalOpen(true)}>Create New Match</button>
            {isModalOpen && (
                <div className={styles.modal}>
                    <h2>Create New Match</h2>
                    <input
                        type="text"
                        placeholder="Match Name"
                        value={newMatch.name}
                        onChange={(e) => setNewMatch({...newMatch, name: e.target.value})}
                    />
                    <select
                        value={newMatch.status}
                        onChange={(e) => setNewMatch({...newMatch, status: e.target.value})}
                    >
                        <option value="Scheduled">Scheduled</option>
                        <option value="In Progress">In Progress</option>
                        <option value="Finished">Finished</option>
                    </select>
                    <select
                        value={newMatch.type}
                        onChange={(e) => setNewMatch({...newMatch, type: e.target.value})}
                    >
                        <option value="Friendly">Friendly</option>
                        <option value="Tournament">Tournament</option>
                        <option value="Other">Other</option>
                    </select>
                    <input
                        type="datetime-local"
                        value={newMatch.actual_start_time}
                        onChange={(e) => setNewMatch({...newMatch, actual_start_time: e.target.value})}
                    />
                    <select
                        value={newMatch.fk_team_host}
                        onChange={(e) => setNewMatch({...newMatch, fk_team_host: Number(e.target.value)})}
                    >
                        <option value={0}>Select Host Team</option>
                        {teams.map(team => (
                            <option key={team.id} value={team.id}>{team.name}</option>
                        ))}
                    </select>
                    <select
                        value={newMatch.fk_team_guest}
                        onChange={(e) => setNewMatch({...newMatch, fk_team_guest: Number(e.target.value)})}
                    >
                        <option value={0}>Select Guest Team</option>
                        {teams.map(team => (
                            <option key={team.id} value={team.id}>{team.name}</option>
                        ))}
                    </select>
                    <select
                        value={newMatch.fk_tournament}
                        onChange={(e) => setNewMatch({...newMatch, fk_tournament: Number(e.target.value)})}
                    >
                        <option value={0}>Select Tournament</option>
                        {tournaments.map(tournament => (
                            <option key={tournament.id} value={tournament.id}>{tournament.name}</option>
                        ))}
                    </select>
                    <button onClick={handleCreateMatch}>Create Match</button>
                    <button onClick={() => setIsModalOpen(false)}>Cancel</button>
                </div>
            )}
            {isLoading ? (
                <div className={styles.loading}>Loading...</div>
            ) : (
                <table className={styles.matchesTable}>
                    <thead>
                    <tr>
                        <th>Date</th>
                        <th>Tournament</th>
                        <th>Teams</th>
                        <th>Status</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {matches.map((match) => (
                        <tr key={match.id}>
                            <td>{new Date(match.actual_start_time).toLocaleDateString()}</td>
                            <td>{match.tournament?.name}</td>
                            <td>{match.host_team?.name} vs {match.guest_team?.name}</td>
                            <td>{match.status}</td>
                            <td>
                                <NavLink to={`/admin/matches/${match.id}`}>Edit</NavLink>
                                <button onClick={() => handleDeleteMatch(match.id)}>Delete</button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}

        </div>
        </>
    );
};

export default AdminPageMatches;